import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import {
  cornerRadiusL,
  scale100,
  spaceL,
  spaceXS,
  xdlColorBorderSoft,
  xdlColorHover,
} from '@xing-com/tokens';

export const StyledButton = styled(TextButton)`
  padding: ${scale100} ${spaceL} !important;
  border: solid 2px ${xdlColorBorderSoft};
  border-radius: ${cornerRadiusL};
  width: 100%;
  height: 100%;
  justify-content: flex-start;

  &:hover {
    background-color: ${xdlColorHover};
  }

  & * {
    overflow: hidden;
  }
`;

export const StyledUserName = styled.span`
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:nth-child(1) {
    margin-right: ${spaceXS};
  }
`;
